export const MISSED_REQUIREMENT_ACTION_NAMES = ['flag', 'autoCancel'];
//# sourceMappingURL=missed-requirement-action-names.js.map